<script>
  export default {
    name: "PrivacyPolicyPage",
  }
</script>

<template>
    <DpPrivacyPolicy/>
</template>
